export default __webpack_public_path__ + "static/media/avatar_pyper2.2d13d92b.mp3";